import { useQuery } from '@tanstack/react-query'
import { sandboxImagesApi } from '@/api/sandboxImages'
import type { SandboxImageKind } from '@/types/sandboxImage'

export function useSandboxImages(enabled = true) {
  return useQuery({
    queryKey: ['sandbox-images'] as const,
    queryFn: sandboxImagesApi.getAll,
    enabled,
  })
}

export function useSandboxImagesByKind(kind: SandboxImageKind, enabled = true) {
  const { data, ...rest } = useSandboxImages(enabled)
  return {
    ...rest,
    data: data?.filter(image => image.kind === kind),
  }
}
